/** Tokens visuais — logs de cobranças */
export const LOGS_COBRANCAS_ACCENT = "#F96030";
const LOGS_COBRANCAS_INK = "#1a237e";

export const modalPaperSx = {
  borderRadius: 3,
  overflow: "hidden",
  maxHeight: "92vh",
  display: "flex",
  flexDirection: "column" as const,
  width: { xs: "100%", sm: "96vw" },
  maxWidth: 720,
};

export const modalHeaderSx = {
  px: 3,
  py: 2.5,
  flexShrink: 0,
  background: `linear-gradient(135deg, ${LOGS_COBRANCAS_INK} 0%, #2d3561 100%)`,
  color: "#fff",
  borderBottom: `3px solid ${LOGS_COBRANCAS_ACCENT}`,
};

export const statusToggleSx = {
  flexWrap: "wrap" as const,
  "& .MuiToggleButton-root": {
    px: 1.25,
    py: 0.75,
    textTransform: "none" as const,
    fontSize: "0.8125rem",
    "&.Mui-selected": {
      bgcolor: "rgba(249, 96, 48, 0.1)",
      borderColor: LOGS_COBRANCAS_ACCENT,
      color: LOGS_COBRANCAS_ACCENT,
      fontWeight: 600,
    },
  },
};
